export default __webpack_public_path__ + "static/media/purple-heart.b3cc4173.svg";